import { isHtmlNoteVisuallyEmpty } from "utils/methods/htmlNoteUtils";

const getLastTextNode = (root) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let last = null;
  let node = walker.nextNode();
  while (node) {
    last = node;
    node = walker.nextNode();
  }
  return last;
};

export const getHistoryEntryContent = (entry) => {
  if (entry == null) return "";
  if (typeof entry === "string") return entry;
  return entry.content ?? "";
};

export const syncEditorPlaceholder = (core, htmlContent) => {
  if (!core) return;

  const hasText = !isHtmlNoteVisuallyEmpty(htmlContent);

  try {
    if (typeof core._checkPlaceholder === "function") {
      core._checkPlaceholder();
      return;
    }
  } catch {
    // fall through
  }

  if (core._placeholder) {
    core._placeholder.style.display = hasText ? "none" : "block";
  }
};

export const placeEditorCursorAtEnd = (core) => {
  const wysiwyg = core?.context?.element?.wysiwyg;
  if (!wysiwyg) {
    core?.focus?.();
    return;
  }

  const lastText = getLastTextNode(wysiwyg);
  if (lastText) {
    try {
      const endOffset = lastText.textContent?.length || 0;
      core.setRange(lastText, endOffset, lastText, endOffset);
      core.focus();
      return;
    } catch {
      // fall through
    }
  }

  try {
    const block = wysiwyg.querySelector("p") || wysiwyg.lastElementChild || wysiwyg;
    const endOffset =
      block.nodeType === 3
        ? block.textContent?.length || 0
        : block.childNodes?.length || 0;
    core.setRange(block, endOffset, block, endOffset);
    core.focus();
  } catch {
    core.focus?.();
  }
};

export const syncEditorAfterHistoryApply = (core, htmlContent) => {
  if (!core) return;

  syncEditorPlaceholder(core, htmlContent);

  if (!isHtmlNoteVisuallyEmpty(htmlContent)) {
    placeEditorCursorAtEnd(core);
  }

  const wysiwyg = core.context?.element?.wysiwyg;
  if (wysiwyg) {
    wysiwyg.dispatchEvent(new Event("input", { bubbles: true }));
  }
};
